import { h } from 'preact';
import { getLazyComponent } from '../../lib/Route';

const AsyncRoute = ({ routeType, ...rest }) => {
  const Comp = getLazyComponent(routeType);

  return <Comp {...rest} />;
};

export default AsyncRoute;
